import React, { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import clsx from 'clsx'
import '../masters/basic.css'
import { AccessOption } from '../AdminSettings/AccessOption'
import { toAbsoluteUrl } from '../../_metronic/helpers'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import httpService from '../../setup/http/httpServices'
import { Input, message } from 'antd'
import { IUserModel } from '../modules/auth/models/UserModel'
import { useSelector, shallowEqual } from 'react-redux'
import { RootState } from '../../setup'
import { ImageCropper } from '../masters/ImageCropper'


var initialValues: any = {
  firstName: '',
  lastName: '',
  email: '',
  webURL: '',
  location: '',
  role: '',
  newPassword: '',
  isActive: true,
  sendNewsletter: true,
  canSubmit: true,
  currentPassword: '',
}

const registrationSchema = Yup.object().shape({
  firstName: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('First name is required')
    .matches(/^(?=.*[A-Za-z]).{3,50}$/, 'Should not contain just numbers'),
  lastName: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Last name is required')
    .matches(/^(?=.*[A-Za-z]).{3,50}$/, 'Should not contain just numbers'),
  webURL: Yup.string()
    .required('Website URL is required')
    .matches(/((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/, 'Must be a valid URL'),

  location: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('location is required')
    .matches(/^(?=.*[A-Za-z]).{3,50}$/, 'Should not contain just numbers'),
  role: Yup.string().required('Role is required'),
  email: Yup.string()
    .email('Wrong format of Email')
    .matches(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      'Wrong format of Email'
    )
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Email is required'),
  // phoneNumber: Yup.string()
  //   .min(10, 'Minimum 10 digits')
  //   .max(12, 'Maximum 13 digits with country code')
  //   .required('Phone Number is required'),
})

export function EditUser() {
  const history: any = useHistory()
  const userId = "0"
  const [loading, setLoading] = useState(false)
  const [loadingReset, setLoadingReset] = useState(false)
  const [loadingResend, setLoadingResend] = useState(false)
  const [hasError, setHasError] = useState(false)
  const [profileDetails, setProfileDetails] = useState(initialValues)
  const [isEditMode, setEditMode] = useState(true)
  const [show, setShow] = useState(isEditMode)
  const [bgImage, setBgImage] = useState(toAbsoluteUrl('/media/logos/profilePicture.png'))
  const [selectedFile, setSelectedFile] = useState(new File([], ''))
  const [toggleCrop, setToggleCrop] = useState(false)
  const [self, setSelf] = useState(false)
  const [currentPassType, setCurrentPassType] = useState(false)
  const [showPass, setShowPass] = useState(false)
  const [userid, setUserid] = useState("")
  const [editProfiles, setEditProfiles] = useState(false)
  const [roleList, setRoleList] = useState<any>([{ role: "Admin", _id: "1" }, { role: "User", _id: "2" }])
  const [currentProfiles, setCurrentProfiles] = useState({
    "Dribble": "",
    "Behance": "",
    "Instagram": "",
    "Github": "",
    "CreativeMarket": "",
    "Linkedin": "",
    "ThemeForest": "",
    "Codepen": "",
    "Twitter": "",
  })
  const [allProfiles, setAllProfiles] = useState({
    "Dribble": "",
    "Behance": "",
    "Instagram": "",
    "Github": "",
    "CreativeMarket": "",
    "Linkedin": "",
    "ThemeForest": "",
    "Codepen": "",
    "Twitter": "",
  })
  const user: IUserModel = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as IUserModel
  const [userDetails, setUserDetails] = useState(initialValues)
  const [accessList, updateAccessList] = useState<any>({
    masters: {
      view: false,
      edit: false,
    },
    campaign: {
      view: false,
      edit: false,
    },
    scheduler: {
      view: false,
      edit: false,
    },
    transactions: {
      view: false,
      edit: false,
    },
    admin: false,
    adminSettings: {
      view: false,
      edit: false,
    },
    support: {
      view: false,
      edit: false,
    },
  })
  function onChange(event: any) {
    let file = event.target.files[0]
    setSelectedFile(file)
    var reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = function () {
      setBgImage('' + reader.result + '')
      setToggleCrop(true)
    }
  }
  function resetImage() {
    setBgImage(toAbsoluteUrl('/media/logos/profilePicture.png'))
    setSelectedFile(new File([], ''))
  }
  async function handleCrop(image: any) {
    setBgImage(image)
    const response = await fetch(image, { mode: 'no-cors' })
    const data = await response.blob()
    setSelectedFile(
      new File([data], selectedFile?.name, {
        type: selectedFile.type,
      })
    )
    formik.setErrors({})
    setToggleCrop(false)
  }
  const handleCancel = () => {
    setBgImage(toAbsoluteUrl('/media/logos/demoImage.svg'))
    setSelectedFile(new File([], ''))
    setToggleCrop(false)
  }
  const uploadPic = () => {
    let fd = new FormData()
    if (selectedFile.size <= 0) return;
    fd.append('avatar', selectedFile)
    httpService.postData(
      '/user/profile-upload/' + userid,
      fd,
      (response: any) => { },
      (error: any) => {
        message.error(error.message)
      }
    )
  }
  const formik = useFormik({
    initialValues: userDetails || initialValues,
    validationSchema: registrationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      let data = { ...values };
      delete data.currentPassword
      delete data.newPassword
      console.log('we are here', data);

      data['profiles'] = currentProfiles
      data['role'] = data['role'] === "1" ? "Admin" : "User"
      data['id'] = userid
      httpService.putData(
        '/user/update/' + userid,
        data,
        (res) => {
          uploadPic()
          console.log(res);
          message.success("Changes Saved!")
        },
        (err) => {
          console.log(err);
          message.error(err)
        }
      )

      // if (!userId && (!values.newPassword || !values.currentPassword)) {
      //   message.error('Password is mendatory for the new user')
      //   setSubmitting(false)
      //   return;
      // } else if (values.newPassword !== values.currentPassword) {
      //   message.error('Password does not match.')
      //   setSubmitting(false)
      //   return;
      // }
      // setLoading(true)
      // setTimeout(() => {
      //   setHasError(false)
      //   setProfileDetails(values)
      //   setLoading(false)
      //   let request: any = values
      //   Object.keys(accessList).forEach((module) => {
      //     if (module === 'admin') {
      //       request.permissions[module] = accessList[module]
      //     } else {
      //       request.permissions[module] = Object.values(accessList[module])
      //     }
      //   })
      //   setSubmitting(false)
      //   request.password = request.newPassword
      //   delete request.newPassword
      //   delete request.currentPassword
      //   if (userId) {
      //     httpService.patchData(
      //       '/user/' + userId,
      //       request,
      //       (response: any) => {
      //         message.success('User details updated.')
      //         uploadPic(userId)
      //         history.push({
      //           pathname: '/adminSettings/profile',
      //           state: {type: 'Access Manager'},
      //         })
      //       },
      //       (error: any) => {
      //         message.error(error.message)
      //       }
      //     )
      //   } else {
      //     httpService.postData(
      //       '/auth/register',
      //       request,
      //       (response: any) => {
      //         message.success('User added.')
      //         uploadPic(response?.data?.data?.user?._id)
      //         history.push({
      //           pathname: '/adminSettings/profile',
      //           state: {type: 'Access Manager'},
      //         })
      //       },
      //       (error: any) => {
      //         message.error(error.message)
      //       }
      //     )
      //   }
      // }, 1000)
    },
  })

  // useEffect(() => {
  //   httpService.getData(
  //     '/role-master/?page=1',
  //     (response: any) => {
  //       setRoleList(response.data.data.roles)
  //       httpService.getData(
  //         userId ? '/user/' + userId : '',
  //         (res: any) => {
  //           const userDetails = res.data.data.user
  //           updateAccessList({
  //             masters: {
  //               view: userDetails.permissions.masters[0],
  //               edit: userDetails.permissions.masters[1],
  //             },
  //             campaign: {
  //               view: userDetails.permissions.campaign[0],
  //               edit: userDetails.permissions.campaign[1],
  //             },
  //             scheduler: {
  //               view: userDetails.permissions.scheduler[0],
  //               edit: userDetails.permissions.scheduler[1],
  //             },
  //             transactions: {
  //               view: userDetails.permissions.transactions[0],
  //               edit: userDetails.permissions.transactions[1],
  //             },
  //             admin: userDetails.permissions.admin,
  //             adminSettings: {
  //               view: userDetails.permissions.adminSettings[0],
  //               edit: userDetails.permissions.adminSettings[1],
  //             },
  //             support: {
  //               view: userDetails.permissions.support[0],
  //               edit: userDetails.permissions.support[1],
  //             },
  //           })
  //           userDetails.role = userDetails?.role?._id
  //           userDetails.newPassword = "";
  //           userDetails.currentPassword = "";
  //           setProfileDetails(userDetails)
  //           if(userDetails?.avatar){
  //             handleCrop('' + userDetails.avatar + '')
  //           }
  //         },
  //         (err: any) => {
  //           message.error({content: err.message})
  //         }
  //       )
  //     },
  //     (error: any) => {}
  //   )
  //   try {
  //     var profileDetail1 = history.location.state?.profileDetails
  //     setProfileDetails(profileDetail1)

  //   } catch {}
  //   if(history?.location?.state?.id==user.userId){
  //     setSelf(true)
  //   }
  // }, [history.location.state?.profileDetails])

  const getData = async () => {
    httpService.getData(
      '/user/' + history.location.pathname.split('/')[3],
      (res) => {
        console.log(res.data.data);
        let data = res.data.data
        let x = {
          firstName: data.firstName,
          lastName: data.lastName,
          email: data.email,
          webURL: data.webURL,
          location: data.location,
          role: data.role === "Admin" ? "1" : "2",
          // phoneNumber: '',
          // newPassword: '',
          isActive: data.isActive,
          sendNewsletter: data.sendNewsletter,
          canSubmit: data.canSubmit,
          currentPassword: data.password,
        }
        setBgImage(process.env.REACT_APP_API_URL + data.avatar)
        setUserid(data._id)
        console.log('user_id', data._id);

        setUserDetails(x)
        setCurrentProfiles(data.profiles ? data.profiles : allProfiles)
        let a = { ...allProfiles };
        Object.entries(data.profiles).map(x => {
          a[x[0]] = x[1]

        })
        setAllProfiles(a)

      },
      (err) => {
        console.log(err);

      }
    )
  }
  useEffect(() => {
    console.log(history)
    getData();
  }, [])

  return (
    <div>

      <div className='mt-0'>
        <form className='m32' onSubmit={formik.handleSubmit} style={{ marginLeft: "250px", width: "972px" }}>
          <div className="backBtnDiv">
            <button className='fw-bolder backBtnUser ' onClick={() => {
              history.push({
                pathname: '/view-users',
                state: { type: 'Users' },
              })
            }}>
              <img src={toAbsoluteUrl('/media/icons/Custom/SideArrowLeft.svg')} alt={"SideArrowLeft"} style={{ marginRight: "5px" }} />
              Back to Users
            </button>
          </div>
          <div className='editUserDiv' style={{ marginBottom: '20px', display: "flex", flexDirection: "column", gap: "1.5rem" }}>
            <div className="verify-email-address-box" >
              <p className='fs-6 m-0'> <img src={toAbsoluteUrl('/media/logos/page.svg')} style={{ marginRight: "0.5rem" }} /> Email Address Verification Pending</p>
              {isEditMode && (
                <span
                  className=' fs-6  text-decoration-underline pointer'
                  onClick={() => {
                    setLoadingResend(true)
                    httpService.postData(
                      '/auth/activate-email',
                      {
                        email: formik.values.email,
                        id: userid
                      },
                      (response: any) => {
                        setLoadingResend(false)
                        message.success('Activation link has been sent to ' + formik.values.email)
                      },
                      (error: any) => {
                        setLoadingResend(false)
                        message.error('Something went wrong')
                      }
                    )
                  }}
                >
                  {!loadingResend && <span className='indicator-label' style={{ color: "#fff" }}>Resend Activation Email</span>}
                  {loadingResend && (
                    <span className='indicator-progress' style={{ display: 'block' }}>
                      Please wait...{' '}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </span>
              )}
            </div>
            <div className="profile-box" style={{ width: "100%", display: "flex" }}>
              <div className="left-box" style={{ width: "20%", display: "flex", flexDirection: "column", gap: "1.5rem" }}>
                <span
                  style={{ width: '120px', height: '120px' }}
                  className='col-fluid svg-icon svg-icon-2x flex svg-icon-dark bg-gray-100 h-120px w-120px rounded-circle'
                >
                  <div
                    className='image-input image-input-circle'
                    data-kt-image-input='true'
                  >
                    <div
                      className='image-input-wrapper w-125px h-125px'
                      style={{ backgroundImage: `url(` + bgImage + `)` }}
                    ></div>
                    <label
                      className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow'
                      data-kt-image-input-action='change'
                      data-bs-toggle='tooltip'
                      hidden={self}
                      data-bs-original-title='Change avatar'
                    >
                      <i className='bi bi-pencil-fill fs-7'></i>
                      <input
                        type='file'
                        name='avatar'
                        accept='.png, .jpg, .jpeg'
                        onChange={(event) => onChange(event)}
                      />
                      <input type='hidden' name='avatar_remove' />
                    </label>

                    {selectedFile.size > 0 && (
                      <span
                        className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow'
                        data-kt-image-input-action='cancel'
                        data-bs-toggle='tooltip'
                        data-bs-dismiss='click'
                        title='Cancel avatar'
                      >
                        <i className='bi bi-x fs-2'></i>
                      </span>
                    )}
                    {selectedFile.size > 0 && (
                      <span
                        className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow'
                        data-kt-image-input-action='remove'
                        data-bs-toggle='tooltip'
                        data-bs-dismiss='click'
                        title='Remove avatar'
                        onClick={resetImage}
                      >
                        <i className='bi bi-x fs-2'></i>
                      </span>
                    )}
                  </div>
                </span>
                <p className='tag-email fs-6 fw-bolder' style={{ width: "110px" }}>
                  <img src={toAbsoluteUrl('/media/logos/linkedin.svg')} alt="icon" style={{ width: "14px", height: "14px", marginRight: "0.5rem" }} />
                  Linkedin</p>
              </div>
              <div className="right-box" style={{ width: "80%" }}>
                <div className=' mb-4' style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                  <div className='col'>
                    <h6 className='fw-bold required'>First Name</h6>
                    <input
                      type='text'
                      placeholder='First Name'
                      //disabled={self}
                      {...formik.getFieldProps('firstName')}
                      className={clsx(
                        'form-control form-control-solid rounded-4 border-0 bg-gray-100',
                        {
                          'is-invalid': formik.touched.firstName && formik.errors.firstName,
                        },
                        {
                          'is-valid': formik.touched.firstName && !formik.errors.firstName,
                        }
                      )}
                    />
                    {formik.touched.firstName && formik.errors.firstName && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>
                          <span className='text-danger' role='alert'>
                            {formik.errors.firstName}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className='col'>
                    <h6 className='fw-bold required'>Last Name</h6>
                    <input
                      type='text'
                      placeholder='Last Name'
                      //disabled={self}
                      {...formik.getFieldProps('lastName')}
                      className={clsx(
                        'form-control form-control-solid rounded-4 border-0 bg-gray-100',
                        {
                          'is-invalid': formik.touched.lastName && formik.errors.lastName,
                        },
                        {
                          'is-valid': formik.touched.lastName && !formik.errors.lastName,
                        }
                      )}
                    />
                    {formik.touched.lastName && formik.errors.lastName && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>
                          <span className='text-danger' role='alert'>
                            {formik.errors.lastName}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className='col '>
                    <h6 className='fw-bold required'>Role/Designation</h6>
                    <select
                      {...formik.getFieldProps('role')}
                      //disabled={self}
                      className={clsx(
                        'form-select text-gray-500 border-0 bg-gray-100',
                        {
                          'is-invalid': formik.touched.role && formik.errors.role,
                        },
                        {
                          'is-valid': formik.touched.role && !formik.errors.role,
                        }
                      )}
                    >
                      <option value="">Role/Designation</option>
                      {roleList.map((role: any) => (
                        <option value={role._id}>{role.role}</option>
                      ))}
                      {/* <option value='Admin'>Admin</option>
                  <option value='Brand'>Brand</option>
                  <option value='Agency'>Agency</option> */}
                    </select>
                    {formik.touched.role && formik.errors.role && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>
                          <span className='text-danger' role='alert'>
                            {formik.errors.role}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className=' mb-4' style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                  <div className="col ">
                    <h6 className='fw-bold required'>Email</h6>
                    <input
                      type='text'
                      placeholder='Email'
                      //disabled={self}
                      {...formik.getFieldProps('email')}
                      className={clsx(
                        'form-control form-control-solid rounded-4 border-0 bg-gray-100',
                        {
                          'is-invalid': formik.touched.email && formik.errors.email,
                        },
                        {
                          'is-valid': formik.touched.email && !formik.errors.email,
                        }
                      )}
                    />
                    {formik.touched.email && formik.errors.email && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>
                          <span className='text-danger' role='alert'>
                            {formik.errors.email}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                  {/* <p className='fw-bold m-0'><img src={toAbsoluteUrl('/media/logos/verifyEmail.svg')} alt="icon" className='me-1' /> Email Address Verified</p> */}
                  <div className="col">
                    <h6 className='fw-bold required'>Website</h6>
                    <Input
                      type='text'
                      placeholder='Website URL'
                      //disabled={self}
                      {...formik.getFieldProps('webURL')}
                      className={clsx(
                        'form-control-solid rounded-4 shadow-none bg-gray-100',
                        {
                          'is-invalid': formik.touched.webURL && formik.errors.webURL,
                        },
                        {
                          'is-valid': formik.touched.webURL && !formik.errors.webURL,
                        }
                      )}
                      suffix={
                        <>
                          <img src={toAbsoluteUrl('/media/logos/link.svg')} alt="dribble" />
                        </>
                      }
                    />
                    {formik.touched.webURL && formik.errors.webURL && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>
                          <span className='text-danger' role='alert'>
                            {formik.errors.webURL}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* {isEditMode && (
                  <span
                    className='link-primary fs-6 fw-bolder text-decoration-underline pointer'
                    onClick={() => {
                      setLoadingResend(true)
                      httpService.postData(
                        '/auth/activate-email',
                        {
                          email: formik.values.email,
                          id: userid
                        },
                        (response: any) => {
                          setLoadingResend(false)
                          message.success('Activation link has been sent to ' + formik.values.email)
                        },
                        (error: any) => {
                          setLoadingResend(false)
                          message.error('Something went wrong')
                        }
                      )
                    }}
                  >
                    {!loadingResend && <span className='indicator-label'>Resend Activation Email</span>}
                    {loadingResend && (
                      <span className='indicator-progress' style={{ display: 'block' }}>
                        Please wait...{' '}
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    )}
                  </span>
                )} */}

                {/* <div className='col m24'>
                <h6 className='fw-bold required'>Location</h6>
                <input
                  type='text'
                  placeholder='Location'
                  //disabled={self}
                  {...formik.getFieldProps('location')}
                  className={clsx(
                    'form-control form-control-solid rounded-4 border-0 bg-gray-100',
                    {
                      'is-invalid': formik.touched.location && formik.errors.location,
                    },
                    {
                      'is-valid': formik.touched.location && !formik.errors.location,
                    }
                  )}
                />
                {formik.touched.location && formik.errors.location && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span className='text-danger' role='alert'>
                        {formik.errors.location}
                      </span>
                    </div>
                  </div>
                )}
              </div> */}
              </div>
            </div>

          </div>




          <div className="editUserDiv" style={{ marginBottom: '20px', paddingTop: "16px", paddingBottom: "16px" }}>
            <div className='d-flex m24'>
              <div className='col'>
                <h6 className='m-0'>Profile Status </h6>
                <p className='m-0 fs-6' style={{ color: "#8E96A0" }}>
                  Inactive profile won’t be able to access their account
                </p>
              </div>
              <div className='col flex justify-content-end'>
                <div className='form-check form-switch form-check-custom form-check-solid'>
                  <input
                    className='form-check-input w-50px h-25px form-check-input-lightPrimary'
                    checked={formik.values.isActive}
                    //disabled={self}
                    type='checkbox'
                    {...formik.getFieldProps('isActive')}
                  />
                </div>
              </div>
            </div>
            <div className="separator my-4"></div>
            <div className='d-flex m24'>
              <div className='col'>
                <h6 className='m-0'>Send Newsletter </h6>

              </div>
              <div className='col flex justify-content-end'>
                <div className='form-check form-switch form-check-custom form-check-solid'>
                  <input
                    className='form-check-input w-50px h-25px form-check-input-lightPrimary'
                    checked={formik.values.sendNewsletter}
                    //disabled={self}
                    type='checkbox'
                    {...formik.getFieldProps('sendNewsletter')}
                  />
                </div>
              </div>
            </div>
            <div className="separator my-4"></div>
            <div className='d-flex m24'>
              <div className='col'>
                <h6 className='m-0'>Submission Approved</h6>
                <p className='m-0 fs-6' style={{ color: "#8E96A0" }}>
                  If disabled user won’t be able to submit websites.
                </p>
              </div>
              <div className='col flex justify-content-end'>
                <div className='form-check form-switch form-check-custom form-check-solid'>
                  <input
                    className='form-check-input w-50px h-25px form-check-input-lightPrimary'
                    checked={formik.values.canSubmit}
                    //disabled={self}
                    type='checkbox'
                    {...formik.getFieldProps('canSubmit')}
                  />
                </div>
              </div>
            </div>
          </div>


          <div className='editUserDiv' style={{ marginBottom: '20px', paddingTop: "16px", paddingBottom: "16px" }}>
            <div className='d-flex align-items-center'>
              <h3 className='m-0 col-9'>Password</h3>
              <button
                type='button'
                className='btn-white fw-bolder btn-outline-dark resetpass col-3'
                onClick={() => {
                  setLoadingReset(true)
                  httpService.postData(
                    '/auth/reset-password',
                    {
                      email: formik.values.email
                    },
                    (response: any) => {
                      setLoadingReset(false)
                      message.success('Reset Password link has been sent to ' + formik.values.email)
                    },
                    (error: any) => {
                      setLoadingReset(false)
                      message.error('Something went wrong')
                    }
                  )
                }}>
                {!loadingReset && <span className='indicator-label'>Send Reset Password Link</span>}
                {loadingReset && (
                  <span className='indicator-progress' style={{ display: 'block' }}>
                    Please wait...{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
            </div>
            {/* <div className='row m24 mb-0'>
            <div className="col ">
            <div className='fv-row mb-10 m16'>
                <div className='d-flex justify-content-between'>
                  <div className='d-flex flex-stack mb-2'>
                    <label className='form-label fw-bolder text-dark fs-6 mb-0 required'>
                      Current Password
                    </label>
                  </div>
                </div>
                <Input
                  placeholder='Current Password'
                  type={!currentPassType?"password":"text"}
                  autoComplete='off'
                  //disabled={self}
                  {...formik.getFieldProps('currentPassword')}
                  className={clsx(
                    'form-control-solid rounded-4 border-0 bg-gray-100 mb-0',
                    {
                      'is-invalid': formik.touched.newPassword && formik.errors.newPassword,
                    },
                    {
                      'is-valid': formik.touched.newPassword && !formik.errors.newPassword,
                    }
                  )}
                  suffix= {
                    <>
                      <img 
                      onClick={()=>{
                          setCurrentPassType(prev=>!prev)
                      }} 
                      src={currentPassType?toAbsoluteUrl('/media/icons/Custom/eye.svg'):toAbsoluteUrl('/media/logos/link.svg')} 
                      style={{cursor:"pointer"}}
                      alt="dribble"/>
                    </>
                  }
                />
                {formik.touched.newPassword && formik.errors.newPassword && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span role='alert'>{formik.errors.newPassword}</span>
                    </div>
                  </div>
                )}
              </div>

            </div>
            
          </div>
          
          {showPass&&<span className='separator m-4 mt-0 border-gray-200 '></span>}
          {showPass&&<div className='row'>
              <h3 className='m-0 col-9'>Change Password</h3>
          </div>} */}
            {/* {showPass&&
          <div className='row'>
            <div className="col-6">
              <div className='fv-row mb-10 m16'>
                <div className='d-flex justify-content-between mt-n5'>
                  <div className='d-flex flex-stack mb-2'>
                    <label className='form-label fw-bolder text-dark fs-6 mb-0 mt-5 required'>
                      {isEditMode ? 'New' : 'Enter'} Password
                    </label>
                  </div>
                </div>
                <input
                  placeholder='New Password'
                  type='password'
                  autoComplete='off'
                  //disabled={self}
                  {...formik.getFieldProps('newPassword')}
                  className={clsx(
                    'form-control form-control-solid rounded-4 border-0 bg-gray-100',
                    {
                      'is-invalid': formik.touched.currentPassword && formik.errors.currentPassword,
                    },
                    {
                      'is-valid': formik.touched.currentPassword && !formik.errors.currentPassword,
                    }
                  )}
                />
                {formik.touched.currentPassword && formik.errors.currentPassword && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span role='alert'>{formik.errors.currentPassword}</span>
                    </div>
                  </div>
                )}
              </div>

            </div>
            <div className="col-6">
              <div className='fv-row mb-10 m16'>
                <div className='d-flex justify-content-between mt-n5'>
                  <div className='d-flex flex-stack mb-2'>
                    <label className='form-label fw-bolder text-dark fs-6 mb-0 mt-5 required'>
                      Confirm Password
                    </label>
                  </div>
                </div>
                <input
                  placeholder='Confirm Password'
                  type='password'
                  autoComplete='off'
                  //disabled={self}
                  // {...formik.getFieldProps('newPassword')}
                  className={clsx(
                    'form-control form-control-solid rounded-4 border-0 bg-gray-100',
                    {
                      'is-invalid': formik.touched.currentPassword && formik.errors.currentPassword,
                    },
                    {
                      'is-valid': formik.touched.currentPassword && !formik.errors.currentPassword,
                    }
                  )}
                />
                {formik.touched.currentPassword && formik.errors.currentPassword && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span role='alert'>{formik.errors.currentPassword}</span>
                    </div>
                  </div>
                )}
              </div>

            </div>
            
            
          </div>
          } */}
            {/* <div className='row'>
              <button
                type='button'
                // disabled
                className='btn btn-primary fw-bolder changepass col-3 mx-4'
                onClick={()=>{
                  if(showPass){
                    httpService.patchData(
                      "/auth/update-password",
                      {id:userid,currentPassword:formik.getFieldProps("currentPassword").value,newPassword:formik.getFieldProps("newPassword").value},
                      (res)=>{
                        console.log(res);
                        
                      },
                      (err)=>{
                        console.log(err);
                      }
                    )
                  }
                  else{
                    setShowPass(true)

                  }
                  
                }}
              >
                Change Password
              </button>
              
          </div> */}

          </div>
          <div className='editUserDiv' style={{ marginBottom: '20px', paddingTop: "16px", paddingBottom: "16px" }}>
            <div className='d-flex align-items-center'>
              <h3 className='m-0 col-10'>Social Profiles</h3>
              <button
                type='button'
                onClick={() => {
                  setEditProfiles(true)
                }
                }
                style={editProfiles ? { color: "gray" } : {}}
                className={!editProfiles ? 'btn-white fw-bolder btn-outline-dark resetpass col-2 m-0' : 'btn-gray-200 fw-bolder resetpass col-2 m-0'}
                disabled={editProfiles}
              >
                Add / Edit Profiles
              </button>
            </div>
            <div className='row m24 mb-2'>
              {Object.entries(currentProfiles).map((x) => {
                // console.log(x);
                if (x[1].toString() !== "") {
                  return (
                    <Input
                      placeholder={x[0] + ' profile link'}
                      // disabled
                      className='form-control-solid rounded-4 shadow-none bg-gray-100 col-4 m-3'
                      style={{ width: '292px', height: '41px', margin: "20px", marginLeft: "0px", marginRight: "20px" }}
                      value={x[1].toString()}
                      prefix={
                        <>
                          <img src={toAbsoluteUrl('/media/logos/' + x[0] + '.svg')} alt={x[0]} style={{ marginRight: "10px" }} />
                        </>
                      }
                      suffix={
                        <>
                          <img src={toAbsoluteUrl('/media/logos/link.svg')} alt="link" />
                        </>
                      }
                    />)
                }


              })}
            </div>
            {editProfiles && <hr className='separator m-3'></hr>}
            {editProfiles && <div className='row m24 mb-2'>
              <h3 className='col-10'>Add Profiles</h3>

              {Object.entries(allProfiles).map((x) => {
                // console.log(x);

                return (
                  <Input
                    placeholder={x[0] + ' profile link'}
                    style={{ width: '292px', height: '41px' }}
                    className='form-control-solid rounded-4 shadow-none bg-gray-100 col-4 m-3'
                    value={x[1].toString()}
                    onChange={(e) => {
                      let a = { ...allProfiles }
                      a[x[0]] = e.target.value
                      setAllProfiles(a)
                    }}
                    prefix={
                      <>
                        <img src={toAbsoluteUrl('/media/logos/' + x[0] + '.svg')} alt={x[0]} style={{ marginRight: "10px" }} />
                      </>
                    }
                    suffix={
                      <>
                        <img src={toAbsoluteUrl('/media/logos/link.svg')} alt="link" />
                      </>
                    }
                  />
                )
              })}


              <div className='m16 w-100 row'>
                <button
                  type='button'
                  className='btn btn-primary fw-bolder col-2 m-3'
                  onClick={() => {
                    setCurrentProfiles(allProfiles)
                    setEditProfiles(false)
                  }}
                >
                  Add Profiles
                </button>
                <button
                  type='button'
                  className='btn btn-gray-200 fw-bolder col-2 m-3'
                  onClick={() => {
                    setEditProfiles(false)
                  }
                  }
                >
                  Cancel
                </button>
              </div>

            </div>}
          </div>
          <div className='saveBtn'>
            <button
              type='submit'
              className='btn btn-primary fw-bolder col-2 m-3'
              onClick={() => {
                formik.handleSubmit();
                console.log('hehe')
              }}
            // onClick={()=>{
            //   httpService.postData(
            //     '/user',
            //     {id:userid,firstName:formik.getFieldProps("firstName").value},
            //     ()=>{},
            //     ()=>{}
            //   )
            // }}
            >
              Save Changes
            </button>
            <button
              type='button'
              className='btn btn-gray-200 fw-bolder col-2 m-3'
            >
              Cancel
            </button>
          </div>
        </form>
      </div>



      {/* <div className='profileSettingDiv accessRight' style={{height: 'fit-content'}}>
        <div className='d-flex '>
          <div className='col-8'>
            <h3 className='m-0'>Access Right Management</h3>
            <p className='m-0 fw-bold text-gray-400 fs-7'>
              Enabling this allows access to everything
            </p>
          </div>
          <div className='col flex justify-content-end'>
            <div className='form-check form-switch form-check-custom form-check-solid '>
              <input
                className='form-check-input w-40px h-20px form-check-input-lightPrimary'
                type='checkbox'
                value=''
                //disabled={self}
                checked={accessList.admin}
                onChange={(e) => {
                  accessList.admin = e.target.checked
                  Object.keys(accessList).forEach((x: any) => {
                    if (x && accessList[x])
                      Object.keys(accessList[x]).forEach((y: any) => {
                        if (y) {
                          accessList[x][y] = e.target.checked
                        }
                      })
                  })
                  updateAccessList({...accessList})
                }}
              />
            </div>
          </div>
        </div>
        <div className='m24'>
          <h6 className='m-0 fs-16'>Masters</h6>
        </div>
        <span className='separator my-4 border-gray-200 mt-2'></span>
        <AccessOption
          label='Can view'
          accessName='masters-view'
          self={self}
          hasAccess={accessList.masters.view}
          handleChange={(e: any) => {
            accessList.masters.view = e
            if (e === false) accessList.admin = false
            updateAccessList({...accessList})
          }}
        ></AccessOption>
        <AccessOption
          label='Can edit'
          accessName='masters-edit'
          self={self}
          hasAccess={accessList.masters.edit}
          handleChange={(e: any) => {
            accessList.masters.edit = e
            if (e === false) accessList.admin = false
            updateAccessList({...accessList})
          }}
        ></AccessOption>
        <div className='m24'>
          <h6 className='m-0 fs-16'>Campaign</h6>
        </div>
        <span className='separator my-4 border-gray-200 mt-2'></span>
        <AccessOption
          label='Can view'
          accessName='campaign-view'
          self={self}
          hasAccess={accessList.campaign.view}
          handleChange={(e: any) => {
            accessList.campaign.view = e
            if (e === false) accessList.admin = false
            updateAccessList({...accessList})
          }}
        ></AccessOption>
        <AccessOption
          label='Can edit'
          accessName='campaign-edit'
          self={self}
          hasAccess={accessList.campaign.edit}
          handleChange={(e: any) => {
            accessList.campaign.edit = e
            if (e === false) accessList.admin = false
            updateAccessList({...accessList})
          }}
        ></AccessOption>
        <div className='m24'>
          <h6 className='m-0 fs-16'>Scheduler</h6>
        </div>
        <span className='separator my-4 border-gray-200 mt-2'></span>
        <AccessOption
          label='Can view'
          accessName='scheduler-view'
          self={self}
          hasAccess={accessList.scheduler.view}
          handleChange={(e: any) => {
            accessList.scheduler.view = e
            if (e === false) accessList.admin = false
            updateAccessList({...accessList})
          }}
        ></AccessOption>
        <AccessOption
          label='Can edit'
          accessName='scheduler-edit'
          self={self}
          hasAccess={accessList.scheduler.edit}
          handleChange={(e: any) => {
            accessList.scheduler.edit = e
            if (e === false) accessList.admin = false
            updateAccessList({...accessList})
          }}
        ></AccessOption>
        <div className='m24'>
          <h6 className='m-0 fs-16'>Transactions</h6>
        </div>
        <span className='separator my-4 border-gray-200 mt-2'></span>
        <AccessOption
          label='Can view'
          accessName='transactions-view'
          self={self}
          hasAccess={accessList.transactions.view}
          handleChange={(e: any) => {
            accessList.transactions.view = e
            if (e === false) accessList.admin = false
            updateAccessList({...accessList})
          }}
        ></AccessOption>
        <AccessOption
          label='Can edit'
          accessName='transactions-edit'
          self={self}
          hasAccess={accessList.transactions.edit}
          handleChange={(e: any) => {
            accessList.transactions.edit = e
            if (e === false) accessList.admin = false
            updateAccessList({...accessList})
          }}
        ></AccessOption>
        <div className='m24'>
          <h6 className='m-0 fs-16'>Admin Settings</h6>
        </div>
        <span className='separator my-4 border-gray-200 mt-2'></span>
        <AccessOption
          label='Can view'
          accessName='admin-view'
          self={self}
          hasAccess={accessList.adminSettings.view}
          handleChange={(e: any) => {
            accessList.adminSettings.view = e
            if (e === false) accessList.admin = false
            updateAccessList({...accessList})
          }}
        ></AccessOption>
        <AccessOption
          label='Can edit'
          accessName='admin-edit'
          self={self}
          hasAccess={accessList.adminSettings.edit}
          handleChange={(e: any) => {
            accessList.adminSettings.edit = e
            if (e === false) accessList.admin = false
            updateAccessList({...accessList})
          }}
        ></AccessOption>
        <div className='m24'>
          <h6 className='m-0 fs-16'>Support</h6>
        </div>
        <span className='separator my-4 border-gray-200 mt-2'></span>
        <AccessOption
          label='Can view'
          accessName='support-view'
          self={self}
          hasAccess={accessList.support.view}
          handleChange={(e: any) => {
            accessList.support.view = e
            if (e === false) accessList.admin = false
            updateAccessList({...accessList})
          }}
        ></AccessOption>
        <AccessOption
          label='Can edit'
          accessName='support-edit'
          self={self}
          hasAccess={accessList.support.edit}
          handleChange={(e: any) => {
            accessList.support.edit = e
            if (e === false) accessList.admin = false
            updateAccessList({...accessList})
          }}
        ></AccessOption>
      </div> */}
      {toggleCrop && <ImageCropper cancel={handleCancel} editImage={handleCrop} image={bgImage} />}
    </div>
  )
}
